export const state = {
  statistics: null,
}
